const API_URL = process.env.REACT_APP_API_URL;

export async function GetPlanAttributesApi(performanceCycleId) {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    
    const response = await fetch(`${API_URL}v1/bulk-plan/plan-attributes/${performanceCycleId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: true,
        message: errorData.message || 'Failed to fetch plan attributes',
      };
    }

    const data = await response.json();
    // Backend already returns {success: true, data: [...]}
    // So just return it directly without wrapping again
    return data;
  } catch (error) {
    console.error('Error fetching plan attributes:', error);
    return {
      success: false,
      error: true,
      message: error.message || 'Network error',
    };
  }
}
